module.exports = __webpack_public_path__ + "static/media/grid.081ed220.jpg";